/** 4 chiffres de la période. */
import { useFormatters } from "../../formats/useFormatters";
import type { ReportKpis as Kpis } from "./types";

export function ReportKpis({ kpis }: { kpis: Kpis }) {
  const { money } = useFormatters();
  const items = [
    { label: "CA HT", value: money(kpis.ca_ht_cents), hint: "Factures − avoirs (date pièce)" },
    { label: "CA TTC", value: money(kpis.ca_ttc_cents), hint: "Factures − avoirs" },
    { label: "Encaissé net", value: money(kpis.collected_ttc_cents), hint: "Paiements − remboursés (TTC)" },
    {
      label: "Impayés",
      value: money(kpis.unpaid_cents),
      hint: `${kpis.unpaid_count} facture${kpis.unpaid_count > 1 ? "s" : ""} en retard`,
      warn: kpis.unpaid_cents > 0,
    },
  ];
  return (
    <section className="fx-dash-4" aria-label="Totaux">
      {items.map((it) => (
        <article key={it.label} className={`fx-kpi${it.warn ? " fx-kpi--warn" : ""}`}>
          <dl>
            <dt>{it.label}</dt>
            <dd>{it.value}</dd>
          </dl>
          <p className="fx-kpi__hint">{it.hint}</p>
        </article>
      ))}
    </section>
  );
}
